"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxOptionMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ListboxOptionLabel = require("../../components/ListboxOptionLabel/ListboxOptionLabel.styles");
var _ListboxOptionMedia = require("../../components/ListboxOptionMedia/ListboxOptionMedia.styles");
var _checkboxStateMixin = require("../checkboxStateMixin");
var _disabledMixin = require("../disabledMixin");
var _iconOffsetMixin = require("../iconOffsetMixin");
var _radioStateMixin = require("../radioStateMixin");
var _typographyMixin = require("../typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance,
    icon = props.icon;
  if (!appearance && !icon) {
    return '';
  }
  return (0, _styledToken.default)({
    fontType: 'ListboxOption.fontType',
    mediaSize: 'ListboxOption.mediaSize',
    iconSize: 'ListboxOption.iconSize',
    iconColor: 'ListboxOption.iconColor',
    horizontalSpacing: 'ListboxOption.horizontalSpacing',
    verticalSpacing: 'ListboxOption.verticalSpacing'
  }, function (_ref) {
    var fontType = _ref.fontType,
      mediaSize = _ref.mediaSize,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing;
    var styles = [(0, _styledComponents.css)(["position:relative;padding-left:", "px;", "{position:absolute;height:", "px;width:", "px;left:", "px;top:", "px;display:flex;justify-content:center;align-items:center;}"], mediaSize + horizontalSpacing * 1.5, _ListboxOptionMedia.StyledListboxOptionMedia, mediaSize, mediaSize, horizontalSpacing, verticalSpacing)];
    if (icon) {
      styles.push((0, _styledComponents.css)(["", "{", " color:", ";}"], _ListboxOptionMedia.StyledListboxOptionMedia, (0, _iconOffsetMixin.iconOffsetMixin)(Object.assign({}, props, {
        fontType: fontType,
        iconSize: iconSize
      })), iconColor));
      return styles;
    }
    styles.push((0, _styledComponents.css)(["", ":before{content:'';", "}&:hover:not([aria-disabled='true']) ", ":before{", "}&[aria-selected='true'] ", ":before{", "}&[aria-disabled='true'] ", ":before{cursor:default;}"], _ListboxOptionMedia.StyledListboxOptionMedia, (0, _radioStateMixin.radioStateMixin)()(props), _ListboxOptionMedia.StyledListboxOptionMedia, (0, _radioStateMixin.radioStateMixin)('hover')(props), _ListboxOptionMedia.StyledListboxOptionMedia, (0, _radioStateMixin.radioStateMixin)('checked')(props), _ListboxOptionMedia.StyledListboxOptionMedia));
    if (appearance === 'checkbox') {
      styles.push((0, _styledComponents.css)(["", ":before{", "}&[aria-selected='true'] ", ":before{", "}"], _ListboxOptionMedia.StyledListboxOptionMedia, (0, _checkboxStateMixin.checkboxStateMixin)()(props), _ListboxOptionMedia.StyledListboxOptionMedia, (0, _checkboxStateMixin.checkboxStateMixin)('checked')(props)));
    }
    return styles;
  })(props);
};
var ListboxOptionMixin = function ListboxOptionMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'ListBoxOption.backgroundColor',
    backgroundColorHover: 'ListboxOption.backgroundColorHover',
    backgroundColorActive: 'ListboxOption.backgroundColorActive',
    backgroundColorPressed: 'ListboxOption.backgroundColorPressed',
    fontType: 'ListboxOption.fontType',
    horizontalSpacing: 'ListboxOption.horizontalSpacing',
    verticalSpacing: 'ListboxOption.verticalSpacing',
    labelFontWeight: 'ListboxOption.Label.fontWeight'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      backgroundColorHover = _ref2.backgroundColorHover,
      backgroundColorActive = _ref2.backgroundColorActive,
      backgroundColorPressed = _ref2.backgroundColorPressed,
      fontType = _ref2.fontType,
      horizontalSpacing = _ref2.horizontalSpacing,
      verticalSpacing = _ref2.verticalSpacing,
      _ref2$labelFontWeight = _ref2.labelFontWeight,
      labelFontWeight = _ref2$labelFontWeight === void 0 ? 'bold' : _ref2$labelFontWeight;
    return (0, _styledComponents.css)(["cursor:pointer;padding:", "px ", "px;background-color:", ";transition:background-color 200ms ease;&:not([aria-disabled='true'])[data-active='true']{background-color:", ";}&:not([aria-disabled='true']):not([data-active='true']):hover{background-color:", ";}&:not([aria-disabled='true']):active{background-color:", ";}&[aria-selected='true'] ", "{font-weight:", ";}&[aria-disabled='true']{", "}", " ", ""], verticalSpacing, horizontalSpacing, backgroundColor, backgroundColorActive, backgroundColorHover, backgroundColorPressed, _ListboxOptionLabel.StyledListboxOptionLabel, labelFontWeight, (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
      disabled: true
    })), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), appearanceCSS(props));
  })(props);
};
exports.ListboxOptionMixin = ListboxOptionMixin;